import { useParams, useNavigate } from 'react-router-dom';
import { LoadingScreen, Button } from '@azyntor-labs/nexus-ui';
import { ArrowLeft } from 'lucide-react';

export const LoadingScreenDemo = () => {
  const { variant } = useParams<{ variant: string }>();
  const navigate = useNavigate();

  const validVariants = ['helix', 'cyber', 'education', 'neural', 'molecular', 'quantum', 'database', 'matrix'];
  const currentVariant = validVariants.includes(variant || '') ? variant : 'helix';

  const variantNames: Record<string, string> = {
    helix: 'Helix',
    cyber: 'Cyber',
    education: 'Education',
    neural: 'Neural',
    molecular: 'Molecular',
    quantum: 'Quantum',
    database: 'Database',
    matrix: 'Matrix'
  };

  return (
    <div className="relative">
      <LoadingScreen
        variant={currentVariant as any}
        message={`${variantNames[currentVariant!]} Loading Animation`}
      />

      {/* Back button overlay */}
      <div className="fixed top-4 left-4 z-[9999]">
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate('/showcase')}
          className="bg-[#0d0d12]/80 backdrop-blur-sm"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Showcase
        </Button>
      </div>
    </div>
  );
};

export default LoadingScreenDemo;
